import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import OdKierowcowSearchbox from "./components/odkierowcowComponents/OdKierowcowSearchbox";
import moment from "moment";
import DateAndTimeFormat from "../../../utilities/DateAndTimeFormat";
import PowiadomieniaService from "./PowiadomieniaService";
import OdKierowcowTable from "./components/odkierowcowComponents/OdKierowcowTable";

export default class OdKierowcowTabContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            powiadomienia: []
        };
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
    }


    componentDidMount() {
        let now = moment();
        let obecny_rok = (now.year());
        let obecny_miesiac = (now.month() + 1);

        let pierwszy_miesiaca = moment(obecny_rok + '-' + obecny_miesiac + '-01')

        let ostatni_miesiaca = moment(obecny_rok + '-' + obecny_miesiac + '-' + moment(now).daysInMonth())

        this.onClickSzukaj({
            dataOd: DateAndTimeFormat.formatYYYYMMDD(pierwszy_miesiaca),
            dataDo: DateAndTimeFormat.formatYYYYMMDD(ostatni_miesiaca),
        })
    }

    onClickSzukaj(obj) {
        PowiadomieniaService.pobierzPowiadomieniaOdKierowcow(obj).then(function (response) {
            if (response.status < 300) {
                this.setState({powiadomienia: response.data})
            }
        }.bind(this))
    }

    render() {

        return (
            <div>
                <Row>
                    <Col xs={12}>
                        <OdKierowcowSearchbox handleClickSearch={this.onClickSzukaj}/>
                    </Col>
                    <Col xs={12}>
                        <OdKierowcowTable data={this.state.powiadomienia}/>
                    </Col>
                </Row>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/komunikaty/powiadomienia/OdKierowcowTabContainer.js